'use client';

import { BlogPostEntry, CategoryFields } from '@/utils/types';

import { Entry } from 'contentful';
import WorkCard from '@/components/WorkCard';
import { useState } from 'react';

type BlogListClientProps = {
  blogs: BlogPostEntry[];
  categories: string[];
};

export default function BlogListClient({
  blogs,
  categories,
}: BlogListClientProps) {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const filteredBlogs =
    selectedCategory === 'All'
      ? blogs
      : blogs.filter((blog) => {
          const category = blog.fields.category as Entry<CategoryFields>;
          if (
            typeof category === 'object' &&
            category !== null &&
            'fields' in category &&
            typeof category.fields.name === 'string'
          ) {
            return category.fields.name === selectedCategory;
          }
        });

  return (
    <div className="container mx-auto p-6">
      <div className="py-8 text-center text-base-content">
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold">
          Blogs
        </h1>
      </div>
      <div className="flex flex-wrap gap-3 my-6">
        <button
          onClick={() => setSelectedCategory('All')}
          className={`btn ${
            selectedCategory === 'All' ? 'btn-primary' : 'btn-outline'
          }`}
        >
          All
        </button>
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            className={`btn ${
              selectedCategory === cat ? 'btn-primary' : 'btn-outline'
            }`}
          >
            {cat}
          </button>
        ))}
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredBlogs.length > 0 ? (
          filteredBlogs.map((blog) => (
            <WorkCard key={blog.sys.id} work={blog} />
          ))
        ) : (
          <p className="text-gray-500">No blogs found in this category.</p>
        )}
      </div>
    </div>
  );
}
